import { GraphNameValues, GraphName } from "../api/generated/api-types";

export type FormatName = 'currency' | 'percentage' | 'people' | null;
export namespace FormatNameValues {
    export const CURRENCY: FormatName = 'currency';
    export const PERCENTAGE: FormatName = 'percentage';
    export const PEOPLE: FormatName = 'people';
    export const NULL: FormatName = null;
}

export type AgeGroup = '-18' | '18-29' | '30-39' | '40-49' | '50-59' | '60-69' | '70+' | null;
export interface IncomeTaxObject {
    gender: number,
    people: number,
    year: number,
    ageGroup: AgeGroup,
    type: string,
    income: any,
    tax: any,
    taxPerPerson: any
}

export interface DividendTaxObject {
    gender: number,
    year: number,
    type: string,
    income: any,
    tax: any,
    taxPerPerson: any
}

export interface ChartSettings {
    title: string;
    description: string;
    type?: string;
    stacked?: boolean;
    uiConfig: any;
    x: {
        label: any
    };
    y: ChartSettingsY;
    y2?: ChartSettingsY[];
}
export interface ChartSettingsY {
    graphName: GraphName;
    label: string;
    renameLabel?: string | any[];
    group?: string;
    keyGroup?: string[];
    format: FormatName | FormatName[];
    limit?: number; // merge smaller objects
}

export interface ChartData {
    x: ChartDataX[],
    y: ChartDataY,
    y2: ChartDataY
}
export interface ChartDataX {
    label: any;
    total: number
}
export interface ChartDataY {
    data: Array<Array<string|number>>,
    format: FormatName,
    stacked: boolean,
    type: string,
    options?: {
        fromZero: boolean;
    }
}



// WEBPACK FOOTER //
// ./src/core/chart-models.ts